import { Outlet } from 'react-router';

import loginBanner from '@treneo/assets/images/login-banner.png';
import { useAppTranslations } from '@treneo/shared/i18n';
import { Colors, Typo } from '@treneo/shared/themes';

import { LanguageBar } from '../language-bar';
import { Logo, LOGO_COLORS, LOGO_VARIANTS } from '../logo';

import {
  AuthStyledCard,
  Banner,
  BottomContainer,
  Container,
  InnerGrid,
  MainGrid,
  SideBanner,
  StyledBannerTittle
} from './public-layout-route.styles';

export const PublicLayoutRoute = () => {
  const { t } = useAppTranslations();

  return (
    <MainGrid>
      <InnerGrid>
        <AuthStyledCard>
          <Container>
            <Outlet />
            <BottomContainer>
              <LanguageBar />
            </BottomContainer>
          </Container>
        </AuthStyledCard>

        <SideBanner>
          <Banner src={loginBanner} />
          <Logo color={LOGO_COLORS.light} variant={LOGO_VARIANTS.banner} />
          <StyledBannerTittle variant={Typo.header} color={Colors.white}>
            {t('auth.bannerTittle')}
          </StyledBannerTittle>
        </SideBanner>
      </InnerGrid>
    </MainGrid>
  );
};
